// Full-document render of the Oscar single-page checkout view: PageSkeleton
// (the React document shell) wrapping the custom checkout header, the
// fraud-critical CyberSource fingerprint + Google Maps loader scripts, and the
// `#checkout-app` SPA mount point.
import React from "react";

import { templates } from "@reactivated";

import { ExternalScript } from "@thelabnyc/thelabui/src/components/ExternalScript";

import { CheckoutPageBody } from "../components/CheckoutPageBody";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as CheckoutHeader } from "./CheckoutHeaderTemplate";
import { Template as MessageBanner } from "./MessageBannerTemplate";

export const Template = (
    props: templates.CheckoutDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            /* Checkout uses its own header: the Django flash queue as
               MessageBanners, plus a trailing blank one whose MessageBanner
               surfaces the Redux payment_error set on a failed payment
               submission, then the checkout header. The footer prop is omitted
               so it defaults to the site SiteFooter. The flash messages arrive
               on page_chrome now; MessageBanner renders each item's text
               (auto-escaped) via its `message` prop. */
            header={
                <>
                    {props.page_chrome.messages.map((message, i) => (
                        <MessageBanner
                            key={i}
                            tags={message.tags}
                            message={message.text}
                        />
                    ))}
                    <MessageBanner tags="" message="" />
                    <CheckoutHeader {...props.checkout_header} />
                </>
            }
        >
            {/* CyberSource device fingerprint (fraud-critical). The device
                profiling completes long before the order is placed. */}
            <p
                style={{
                    background: `url(${props.fingerprint_img_1_url})`,
                }}
            />
            <img src={props.fingerprint_img_2_url} alt="" />
            <ExternalScript
                src={props.fingerprint_js_url}
                type="text/javascript"
                async={true}
            />
            {/* Google Maps Places powers the address-autocomplete inputs; it
                still loads well before the address step renders. */}
            <ExternalScript
                src={`https://maps.googleapis.com/maps/api/js?v=3&key=${props.google_maps_api_key}&libraries=places`}
                type="text/javascript"
                async={true}
            />
            <CheckoutPageBody />
        </PageSkeleton>
    );
};
